/*eslint-disable*/
import React, { useEffect, useMemo, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    MenuItem,
    Select,
    FormControl,
    Grid,
    Box,
    CircularProgress,
} from "@mui/material";

import {
    DataGridPremium,
    GridColDef,
    useGridApiRef,
    useKeepGroupedColumnsHidden,
    GridToolbar,
} from "@mui/x-data-grid-premium";
import { BarChart } from "@mui/x-charts/BarChart";
import { SelectChangeEvent } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import FastAPIClient from "../../client";
import config from "../../config";
import { blueberryTwilightPalette } from "@mui/x-charts/colorPalettes";

import CustomBarChart from "./CustomBarChart";
import StatCard from "../LayoutComponents/StatCard";

import { frFR } from "@mui/x-data-grid/locales";

const client = new FastAPIClient(config);

type UserKilometerLog = {
    user_id: string;
    first_name: string;
    last_name: string;
    activity_time: string;
    kilometers: number;
    team_name: string;
    warehouse_name: string;
};

interface UserKilometerProps {
    // utilisateurSélectionné: string;
    // équipeSélectionnée: string;
    // entrepôtSélectionné: string;
    // périodeTemps: string;
}

const UserKilometerTable: React.FC<UserKilometerProps> = ({}) => {
    const [data, setData] = useState<UserKilometerLog[] | null>(null);
    const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([
        dayjs().startOf("week"),
        dayjs().endOf("week"),
    ]);

    const apiRef = useGridApiRef();

    const initialState = useKeepGroupedColumnsHidden({
        apiRef,
        initialState: {
            rowGrouping: {
                model: ["salesRep", "year", "month", "day"],
            },
            sorting: {
                sortModel: [{ field: "dateTime", sort: "desc" }],
            },
        },
    });

    useEffect(() => {
        fetchKilometers();
    }, []);

    const fetchKilometers = async () => {
        try {
            const response = await client.fetchUserKilometers(); // Endpoint pour les données de kilomètres
            console.log("kilometers", response.results);
            setData(response.results);
        } catch (error) {
            console.error(
                "Erreur lors de la récupération des kilomètres :",
                error
            );
        }
    };

    const filteredData = data;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box mt={4} style={{ height: 500, width: "100%" }}>
                <DataGridPremium
                    rows={(filteredData || []).map((row, index) => ({
                        id: index,
                        salesRep: `${row.first_name} ${row.last_name}`,
                        dateTime: dayjs(row.activity_time).format(
                            "YYYY-MM-DD HH:mm:ss"
                        ),
                        day: dayjs(row.activity_time).format("YYYY-MM-DD"),
                        year: dayjs(row.activity_time).format("YYYY"),
                        month:
                            dayjs(row.activity_time)
                                .format("MMMM")
                                .charAt(0)
                                .toUpperCase() +
                            dayjs(row.activity_time).format("MMMM").slice(1),

                        kilometers: row.kilometers,
                    }))}
                    showToolbar
                    columns={
                        [
                            {
                                field: "salesRep",
                                headerName: "Représentant Commercial",
                                flex: 2,
                                minWidth: 400,
                            },
                            {
                                field: "year",
                                headerName: "Année",
                                flex: 0.8,
                            },
                            {
                                field: "month",
                                headerName: "Mois",
                                flex: 1,
                            },
                            {
                                field: "day",
                                headerName: "Jour",
                                flex: 1,
                            },
                            {
                                field: "dateTime",
                                headerName: "Date et Heure",
                                flex: 1,
                            },
                            {
                                field: "kilometers",
                                headerName: "Kilomètres",
                                type: "number",
                                flex: 1,
                            },
                        ] as GridColDef[]
                    }
                    disableRowSelectionOnClick
                    apiRef={apiRef}
                    initialState={initialState}
                    rowGroupingColumnMode="multiple"
                    sx={{
                        backgroundColor: "#fff",
                        borderRadius: 2,
                        boxShadow: "none", // 🔥 pas d'ombre
                    }}
                    localeText={
                        frFR.components.MuiDataGrid.defaultProps.localeText
                    }
                    slotProps={{
                        toolbar: {
                            csvOptions: {
                                fileName: `Kilométrage_${dayjs().format(
                                    "YYYY-MM-DD"
                                )}`,
                            },
                            excelOptions: {
                                fileName: `Kilométrage__${dayjs().format(
                                    "YYYY-MM-DD"
                                )}`,
                            },
                        },
                    }}
                />
            </Box>
        </LocalizationProvider>
    );
};

export default UserKilometerTable;
